import React, {useState} from 'react';


import './App.css';
import {CssBaseline, ThemeProvider} from "@mui/material";
import {darkTheme} from "./theme";
import CommissionsPage from "./routes/Commissions";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import {Route, Routes} from "react-router-dom";




function App() {
    const [value, setValue] = useState("Nothing clicked")
    return (
        <ThemeProvider theme={darkTheme}>

            <CssBaseline />
            <main className="App">
                <NavBar />

                <Routes>

                    <Route path="/" element={<CommissionsPage />} />

                </Routes>

                <Footer />
            </main>
        </ThemeProvider>

    )
}

export default App;
